import React from 'react';
import classNames from 'classnames';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { Redirect } from 'react-router';
import { withRouter } from 'react-router-dom';
import { get } from 'lodash';
import queryString from 'query-string';

import { URLS } from 'rebook/apps/base/constants';
import Button from 'rebook/apps/base/components/Button';
import Form, { FormControl, FormRow } from 'rebook/apps/base/components/form/Form';
import FormTextInput from 'rebook/apps/base/components/form/FormTextInput';
import validateForm from 'rebook/apps/base/components/form/validateForm';
import AuthForm from 'rebook/mybook/App/AuthForm';
import * as SeoActions from 'rebook/apps/base/actions/SeoActions';

import styles from './style.scss';


const GiftSubmited = ({ uuid }) => (
  <Redirect to={`/payments/status/${uuid}`} />
);

const GiftAuthForm = () => (
  <div>
    <p>Войдите или зарегистрируйтесь, чтобы активировать подарочный код</p>
    <div className="billetContainer">
      <AuthForm
        type="registration"
        shouldHideTitle
        noSuccessNotification
        GALabel="GiftCode" />
    </div>
  </div>
);

class GiftCodeView extends React.Component {
  constructor(props) {
    super(props);
    const queryParams = queryString.parse(props.location.search);
    const invitePromocode = get(queryParams, 'invite', null);
    this.state = {
      form: {},
      errorList: {},
      isInProgress: false,
      success: null,
      invitePromocode,
    };
  }

  componentWillMount() {
    this.props.SeoActions.setData({
      canonicalUrl: `https://${BASE_HOST}${URLS.activateGift}`,
      title: `Активация подарочного кода на подписку MyBook. ` +
       `Читайте более ${this.props.booksPerSubscriptionCounter.total} книг в электронной библиотеке MyBook`,
    });
  }

  componentWillUnmount() {
    this.props.SeoActions.resetData();
  }

  updateFormField(input) {
    this.setState(
      (prevState) => {
        return {
          errorList: {},
          form: {
            ...prevState.form,
            ...input,
          },
        };
      }
    );
  }

  handleSubmit(submit) {
    this.setState({
      errorList: {},
      isInProgress: true,
    });

    const form = validateForm(this.state.form);
    submit(form);
  }

  handleSuccess(data) {
    window.scrollTo(0, 0);
    ga('send', 'event', 'Payments', 'Activate', 'PromoCode');
    this.setState({
      errorList: {},
      isInProgress: false,
      success: get(data, 'payment.uuid', false),
    });
  }

  handleError(errorList) {
    ga('send', 'event', 'Payments', 'Error', 'PromoCode');
    this.setState({
      errorList,
      isInProgress: false,
      success: false,
    });
  }

  render() {
    const { errorList, isInProgress, success, invitePromocode } = this.state;
    const { user } = this.props;
    return (
      <div className={classNames(styles.contentBackground, 'backgroundContainer')}>
        <div className={styles.wrapper}>
          <header className={styles.title}>
            <div className="title-1">Подарочный код</div>
          </header>
          <div className={styles.content}>
            {!user && <GiftAuthForm />}
            {user && (
              <div className={classNames('billetContainer', styles.container)}>
                {success
                  ? <GiftSubmited uuid={this.state.success} />
                  : (
                    <Form
                      action="/api/gift-activate/"
                      method="post"
                      extraClassName="jest-giftcode-form"
                      onSubmit={(callback) => this.handleSubmit(callback)}
                      onSuccess={(data) => this.handleSuccess(data)}
                      onError={(errorList) => this.handleError(errorList)}>
                      <FormRow>
                        <FormTextInput
                          extraClassName={classNames(
                            'cy-giftcode-form-code',
                            'jest-giftcode-form-code',
                            styles.input,
                          )}
                          validationMessageExtraClassName="jest-giftcode-form-code-error"
                          errorList={errorList.code || errorList.non_field_errors}
                          isDisabled={isInProgress}
                          isRequired
                          value={invitePromocode || ''}
                          isRequiredError="Введите код в поле"
                          label="Если у вас есть подарочный код MyBook, активируйте его здесь"
                          onUpdate={(input) => this.updateFormField(input)}
                          name="code" />
                      </FormRow>
                      <FormControl>
                        <Button
                          handleClick={()=>{ga('send', 'event', 'PushButton', 'ActivateLogged');}}
                          extraClassName="jest-giftcode-form-submit"
                          isInProgress={isInProgress}>
                          Активировать
                        </Button>
                      </FormControl>
                    </Form>
                  )
                }
              </div>
            )}
          </div>
        </div>
      </div>
    );
  }
}

function mapStateToProps(state) {
  return {
    user: state.user,
    booksPerSubscriptionCounter: state.booksPerSubscriptionCounter,
  };
}

function mapDispatchToProps(dispatch) {
  return {
    SeoActions: bindActionCreators(SeoActions, dispatch),
  };
}

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(GiftCodeView));
